import { C } from "@fullcalendar/core/internal-common";
import { environment } from "src/environments/environment";

export class Config {
  //server
  public static apiUrl = environment.serverUrl;

  // Identity
  public static Identity = {
    RefreshToken: "/Identity/api/Identity/RefreshToken",
    logOut: "/Identity/api/Identity/Logout",
    GenerateSsoToken: "/Identity/api/Identity/GenerateSsoToken",
  };

  // License
  public static License = {
    CheckLicense: "/api/FeatureManager/CheckLicence",
  };

  // Translation
  public static Translation = {
    Get: "/Utilities/api/CMS/Resource/Get",
    GetUnAuth: "/Utilities/api/CMS/Resource/GetUnAuthorizedResources",
    Set: "/Utilities/api/CMS/Resource/Set",
  };

  //User Management
  public static UserManagement = {
    GetAll: "/UserManagement/api/User/GetAll",
    GetUsersByIds: "/UserManagement/api/User/GetUsersByIds",
    getOwners: "/UserManagement/api/User/GetOwners",
    updateUser: "/UserManagement/api/User/Update",
    updateProfilePicture: "/UserManagement/api/User/UpdateProfilePicture",
    GroupId: "/UserManagement/api/User/User/Get/GroupId",
    Recursive: "/UserManagement/api/User/GetInGroup/Recursive",
    GetUsersByGroup: "/UserManagement/api/User/Get/Group",
    GetInGroups: "/UserManagement/api/User/GetInGroups/Recursive",
    UsersFullName: "/UserManagement/api/User/GetUsersByFullName",
    GetAllGrades: "/UserManagement/api/User/Grade/GetAll",
    GetAllUsers: "/UserManagement/api/User",
    GetUsersByGroupId: "/UserManagement/api/User/Get/Group",
    DownloadTemplate: "/UserManagement/api/User/Import/DownloadTemplate",
    uploadFile: "/UserManagement/api/User/Import",
    GetCoordinators: "/UserManagement/api/my/coordinators",
  };

  public static Committees = {
    Get: "/UserManagement/api/Committees/Get",
    GetAll: "/UserManagement/api/Committees/Get/All",
    GetAllActive: "/UserManagement/api/Committees/GetAll",
    Activate: "/UserManagement/api/Committees/Activate/{id}/{status}",
    Delete: "/UserManagement/api/Committees/Delete/{id}",
    Create: "/UserManagement/api/Committees/Create",
    Update: "/UserManagement/api/Committees/Update",
    Members: "/UserManagement/api/Committees/Get/Members/",
  };

  // Groups
  public static Groups = {
    Get: "/UserManagement/api/Groups/Get",
    GetAll: "/UserManagement/api/Groups/GetAll",
    GetAllGroups: "/UserManagement/api/Groups/GetAllGroups",
    GetPagedGroups: "/UserManagement/api/Groups/GetPagedGroups",
    GetGroups: "/UserManagement/api/Groups/GetGroups",
    GetUserGroup: "/UserManagement/api/User/User/Get/GroupId",
    GetMyGroups: "/UserManagement/api/Groups/GetMyGroups",
    GetGroupLevel: "/UserManagement/api/Groups/Get/Level/Children/",
  };

  //Service
  public static Service = {
    createService: "/ServiceDesk/api/Service/Create",
    updateService: "/ServiceDesk/api/Service/Update",
    getAllService: "/ServiceDesk/api/Service/GetAll",
    getService: "/ServiceDesk/api/Service/Get",
    toggleActivate: "/ServiceDesk/api/Service/ToggleActivate",
    Perform: "/ServiceDesk/api/Workflow/Perform",
    GetStates: "/ServiceDesk/api/Workflow/Instance/States",
    ReassignTask: "/ServiceDesk/api/Workflow/Task/Reassign",
    Override: "/ServiceDesk/api/Workflow/Force/Perform",
    CancelReassignTask: "/ServiceDesk/api/Workflow/Task/Reassign/Cancel",
    CancelReassignTaskMeeting:
      "/ServiceDesk/api/Workflow/Task/Reassign/Cancel/Meeting",
    CancelRequest: "/ServiceDesk/api/WorkFlow/Cancel/Perform",
  };

  //Service
  public static EService = {
    getAllEService: "/ServiceDesk/api/EService/All",
    // createEService: '/ServiceDesk/api/EService/Create',
    updateEService: "/ServiceDesk/api/EService/Update",
    moveEService: "/ServiceDesk/api/EService/Move",
    deleteEService: "/ServiceDesk/api/EService/Delete",
    getEService: "/ServiceDesk/api/EService/Details/",
    exportEServices: "/ServiceDesk/api/EService/Export",
    active: "/ServiceDesk/api/EService/Active",
  };

  //Services Catalogues
  public static ServicesCatalogues = {
    getAllServicesCatalogues: "/ServiceDesk/api/ServiceCatalogue/Get",
    toggleFavourite: "/ServiceDesk/api/ServiceCatalogue/SetFavourite",
    setRating: "/ServiceDesk/api/ServiceCatalogue/SetRating",
    getFavouritesServices: "/ServiceDesk/api/ServicesCatalogues/GetFavourites",
    getCategories: "/ServiceDesk/api/ServiceCatalogue/GetCategories",
  };

  //Mange Scorecards
  public static MangeScorecards = {
    getAll: "/Performance/api/Scorecard/View",
    updatescorecard: "/Performance/api/Scorecard/Update",
    setCurrent: "/Performance/api/Scorecard/SetCurrent",
    delete: "/Performance/api/Scorecard/Delete/{id}",
    getWithDetails: "/Performance/api/Scorecard/GetWithDetails/{id}",
    startScorecard: "/Performance/api/Scorecard/Start",
    getStatusDetails: "/Performance/api/Scorecard/StatusDetails",
    getYearKPIs: "/Performance/api/Goal/GetKPIs",
    getYearGoals: "/Performance/api/Goal/CurrentYearGoals",
    selectedItems: "/Performance/api/Scorecard/GetTree/SelectedItems",
    exportExcel: "/Performance/api/Dashboard/Export",
  };

  //Lookups
  public static Lookups = {
    lookupService: "/Utilities/api/Lookup/GetAll",
    GetByLookupType: "/Utilities/api/Lookup/Get",
    changeLookupStatus: "/Utilities/api/Lookup/UpdateStatus",
    deleteLookup: "/Utilities/api/Lookup/Delete",
    updateLookup: "/Utilities/api/Lookup/Update",
    createlookup: "/Utilities/api/Lookup/Create",
    createTranslation: "/Utilities/api/Translator/Translate",
    lookupProcess: "/WorkflowEngine/api/Process/Enabled/Search",
    lookupAgent: "/UserManagement/api/User/GetAgents",
    lookupGroups: "/UserManagement/api/Groups/Get",
    lookupRoles: "/UserManagement/api/Role/GetAll",
    lookupForms: "/ServiceDesk/api/FormBuilder/GetAllForms",
    lookupGoalTypes: "/GoalEngine/api/GoalType/Get",
    lookupEnabledGoalTypes: "/GoalEngine/api/GoalType/Get/Enabled",
    lookupPerformanceGroups: "/Performance/api/Scorecard/Groups",
    getMyHierarchy: "/UserManagement/api/User/Get/MyHierarchy",
    getExternalLookups: "/Eppm/api/Lookup/Project/ExternalLookups",
    getDepartments: "/Eppm/api/Lookup/Project/GetDepartments",
    getSections: "/Eppm/api/Lookup/Project/GetAreas",
    getPriorityLevels: "/Eppm/api/Lookup/Project/PriorityLevels",
    getProjectStatus: "/Eppm/api/Lookup/Project/Status",
    getDelegationStatus: "/WorkflowEngine/api/Lookup/DelegationStatus",
    getLookupRoles: "/Utilities/api/LookupRole/Get",
    createLookupRole: "/Utilities/api/LookupRole/Create",
    removeLookupRole: "/Utilities/api/LookupRole/Delete",
    getLooktypeByServiceName: "/Utilities/api/Lookup/Get/",
    GetRolesByIds: "/UserManagement/api/Role/GetRolesByIds",
    locationLookup:
      "/Utilities/api/Lookup/Get/Locations?ServiceName=ServiceDesk",
    decisionType:
      "/Utilities/api/Lookup/Get/DecisionType?ServiceName=Committee",
    getLookupId: "/Utilities/api/Lookup/Get/Id",
    getLookupCode: "/Utilities/api/Lookup/GetByCode",
    getDynamicAPIs: "/Utilities/api/Api/Get",
    getConsumers: "/WorkflowEngine/api/Lookup/GetConsumers",
    getGetGroupByLevel: "/UserManagement/api/Groups/GetGroupByLevel",
    getGroupById: "/UserManagement/api/Groups/GetById",
    getAssetsAvailabiltyTypes: "/Booking/api/lookups/availability-types",
    getAssetsTypes: "/Booking/api/lookups/asset-types",
    getFacilitites: "/Booking/api/lookups/facilities",
    getDays: "/Booking/api/lookups/days",
    getPricingMechanisms: "/Booking/api/lookups/pricing-mechanisms",
    getCurrencies: "/Booking/api/lookups/currencies",
    getTargetAudiences: "/Booking/api/lookups/target-audiences",
    getCapacityUnits: "/Booking/api/lookups/capacity-units",
    getEventTypes: "/Booking/api/lookups/event-types",
    getBookingStatus: "/Booking/api/lookups/booking-status",
  };

  //Requests
  public static requests = {
    getAll: "/ServiceDesk/api/Requests/GetRequests",
    SubmitRequest: "/ServiceDesk/api/Requests/SubmitRequest",
    getHistory: "/ServiceDesk/api/Requests/GetHistory",
    GetStatus: "/ServiceDesk/api/Requests/GetStatus",
    UpdateRating: "/ServiceDesk/api/Requests/UpdateRating",
    GetCount: "/ServiceDesk/api/Requests/GetCount",
    GetComments: "/ServiceDesk/api/Requests/GetComments/",
    AddComment: "/ServiceDesk/api/Requests/Comment",
    DeleteComment: "/ServiceDesk/api/Requests/DeleteComment/",
    UpdateRequest: "/ServiceDesk/api/Requests/UpdateRequest",
  };

  // Form Builder
  public static FormBuilder = {
    GetAll: "/ServiceDesk/api/FormBuilder/Get",
    GetAllForms: "/ServiceDesk/api/FormBuilder/GetAllForms",
    CreateForm: "/ServiceDesk/api/FormBuilder/CreateForm",
    GetServiceForm: "/ServiceDesk/api/FormBuilder/GetServiceForm",
    ToggleActivate: "/ServiceDesk/api/FormBuilder/ToggleActivate",
    GetDynamicFormById: "/ServiceDesk/api/FormBuilder/GetDynamicFormById",
    UpdateDynamicForm: "/ServiceDesk/api/FormBuilder/UpdateDynamicForm",
    CreateDynamicForm: "/ServiceDesk/api/FormBuilder/CreateDynamicForm",
  };

  // Performance
  public static Performance = {
    getAll: "/Performance/api/Scorecard/Get/",
    getGoal: "/Performance/api/Goal/Get",
    getGoalView: "/Performance/api/Goal/View",
    getScorecardAll: "/Performance/api/Scorecard/All",
    performanceGetScorecards: "/Performance/api/Dashboard/GetScorecards",
    createGoal: "/Performance/api/Goal/Create",
    updateGoal: "/Performance/api/Goal/Update",
    deleteGoal: "/Performance/api/Goal/Delete",
    GetStatus: "/Performance/api/Scorecard/GetStatus",
    sumbitScoreCard: "/Performance/api/Scorecard/Submit",
    MoveToNextLeveL: "/Performance/api/Scorecard/MoveToNextLevel/",
    CloseApprovalCycle: "/Performance/api/Scorecard/closeApprovalCycle/",
    GetMyActions: "/Performance/api/Scorecard/GetMyActions",
    Perform: "/Performance/api/Workflow/Perform",
    SubmissionPeriod: "/Performance/api/SubmissionPeriod/GetAll",
    GetSubmissionPeriod: "/Performance/api/SubmissionPeriod/Get",
    GetGoalForUpdate: "/Performance/api/Goal/GetForUpdate/",
    GetCurrent: "/Performance/api/Scorecard/GetCurrent",
    UpdateProgress: "/Performance/api/Goal/UpdateProgress",
    GetMyLevels: "/Performance/api/Scorecard/GetLevels",
    GetMyGroups: "/Performance/api/Scorecard/Groups",
    GetInformativeGoals: "/Performance/api/Goal/GetInforamtiveGoals",
    GetPeriodGoals: "/Performance/api/ScorecardSubmission/GetPeriodGoals",
    GetPerformance: "/Performance/api/ScorecardSubmission/GetPerformance",
    OpenPeriod: "/Performance/api/ScorecardSubmission/Set/{index}",
    Export: "/Performance/api/ScorecardSubmission/Export",
    GetPerformanceEvaluation:
      "/Performance/api/ScorecardSubmission/GetYearEvaluation",
    canClose: "/Performance/api/Scorecard/CanClose",
    getMyHirechy: "/UserManagement/api/User/Get/Performance/MyHierarchy",
    submittionStatusDetails:
      "/Performance/api/ScorecardSubmission/Submission/Status",
    submit: "/Performance/api/ChangeRequestStorecard/Submit",
    GetActions: "/Performance/api/ChangeRequestStorecard/GetMyActions",
    GetDetails: "/Performance/api/ChangeRequestStorecard/View",
    getRelatedChangeRequests:
      "/Performance/api/ChangeRequestStorecard/GetRelatedChangeRequests",
    getChangerequestGoals: "/Performance/api/Goal/Get/ChangeRequestGoals",
    getGoalsByLevelAndGroup: "/Performance/api/Goal/Get",
    updateScorecard: "/Performance/api/ChangeRequestStorecard/Update",
    GetCount: "/Performance/api/ChangeRequestStorecard/GetCount",
    GetInformativeByYear: "/Performance/api/Scorecard/GetInformative",
    GetTree: "/Performance/api/Scorecard/GetTree",
  };

  // Performance Dashboard
  public static PerformanceDashboard = {
    GetPerformanceTodate: "/Performance/api/Dashboard/GetPerformanceTodate",
    GetGoalTypePerformance: "/Performance/api/Dashboard/GetGoalTypePerformance",
    GetSubgroupPerformance: "/Performance/api/Dashboard/GetSubgroupPerformance",
    GetYearPerformance: "/Performance/api/Dashboard/GetYearPerformance",
    HasPermission: "/Performance/api/Dashboard/HasPermission",
  };

  // Agent Queue
  public static AgentQueue = {
    GetStatistics: "/ServiceDesk/api/Agent/Statistics",
    GetAll: "/ServiceDesk/api/Agent/GetAll",
    export: "/ServiceDesk/api/Agent/ExportAgentList",
    GetCount: "/ServiceDesk/api/Agent/GetCount",
  };

  // File Service
  public static fileService = {
    upload: "/FileService/api/Attachment/Upload",
    getFilesUrls: "/FileService/api/File/Urls",
    downloadFile: "/FileService/api/Attachment/DownloadFile",
    UploadFile: "/FileService/api/File/upload",
    GetFile: "/FileService/api/File/GetFiles",
    GetSingleFile: "/FileService/api/File/GetFile",
  };

  // Profile
  public static Profile = {
    getProfile: "/UserManagement/api/Profile/Get",
  };

  // Configuration
  public static Configuration = {
    GetAll: "/Performance/api/Configuration/StatusWindow/GetAll",
    updateConfiguration: "/Performance/api/Configuration/StatusWindow/Edit",
    GetAllGoal: "/GoalEngine/api/GoalType/Get",
    GetEnabledGoal: "/GoalEngine/api/GoalType/Get/Enabled",
    toggleEnabled: "/GoalEngine/api/GoalType/Enable",
  };

  // Dashboard
  public static Dashboard = {
    GetProjectsStatistics: "/Eppm/api/Statistics/Projects",
    GetBudgetStatistics: "/Eppm/api/Statistics/Budget",
    GetProjectManagers: "/Eppm/api/Statistics/ProjectManagers",
    GetSectorsData: "/Eppm/api/Statistics/Sectors",
    GetDepartments: "/Eppm/api/Statistics/Departments",
    GetSectors: "/Eppm/api/Lookup/Project/GetSectors",
    GetPriorities: "/Eppm/api/Statistics/Projects/Priorities",
    GetCategories: "/Eppm/api/Statistics/Projects/Categories",
    GetOrigins: "/Eppm/api/Statistics/Projects/Origins",
    GetDeliverables: "/Eppm/api/Statistics/Deliverables",
    GetHighRisks: "/Eppm/api/Dashboard/HighRisks",
    GetDetails: "/Eppm/api/Dashboard/Projects/Details",
    GetTotalBudgetAndSpent: "/Eppm/api/Statistics/Budget/PlannedAndActual",
    GetMainTaskStatus: "/Committees/api/Dashboard/MainTaskStatus",
    GetTaskStatusList: "/Committees/api/Dashboard/TaskStatusList",
    GetKpiStatistics: "/Committees/api/Dashboard/KpiStatistics",
    GetKpiStatisticsList: "/Committees/api/Dashboard/KpiStatisticsList",
    ExportKPIs: "/CommitteeKpi/Export",
  };

  // Scorecard Submission
  public static ScorecardSubmission = {
    GetScorecardSubmission: "/Performance/api/ScorecardSubmission/Get",
    SubmitScorecard: "/Performance/api/ScorecardSubmission/Submit",
    Extend: "/Performance/api/ScorecardSubmission/Extend",
    Close: "/Performance/api/ScorecardSubmission/Close",
    Publish: "/Performance/api/SubmissionPeriod/Publish",
    UnPublish: "/Performance/api/SubmissionPeriod/UnPublish",
    Verify: "/Performance/api/ScorecardSubmission/Verify",
  };

  // Chnage Requests
  public static chnageRequest = {
    getAllCR: "/Committees/api/ChangeRequest/Get",
    getStatistics: "/Committees/api/ChangeRequest/Statistics",
    getAll: "/Performance/api/ChangeRequestStorecard/View",
    submit: "/Performance/api/ChangeRequestStorecard/Submit",
    GetStatus: "/Performance/api/ChangeRequestStorecard/GetStatus",
    GetActions: "/Performance/api/ChangeRequestStorecard/GetMyActions",
    GetDetails: "/Performance/api/ChangeRequestStorecard/View",
    getRelatedChangeRequests:
      "/Performance/api/ChangeRequestStorecard/GetRelatedChangeRequests",
    getChangerequestGoals: "/Performance/api/Goal/Get/ChangeRequestGoals",
    getGoalsByLevelAndGroup: "/Performance/api/Goal/Get",
    updateScorecard: "/Performance/api/ChangeRequestStorecard/Update",
    GetCount: "/Performance/api/ChangeRequestStorecard/GetCount",
    GetKpisDetails: "/Committees/api/CommitteeKpi/GetById",
    GetTasksDetails: "/Committees/api/MainTask/GetById",
  };

  // Scorecard
  public static scorecard = {
    create: "/Performance/api/Scorecard/Create",
    GetGoalsToLevel: "/Performance/api/Scorecard/GetGoalsToLevel",
    GetCount: "/Performance/api/Scorecard/GetCount",
  };

  // Notification
  public static Notification = {
    GetCount: "/Utilities/api/Notification/Notification/Count",
    GetNotifications: "/Utilities/api/Notification/Notification/Get",
    ReadNotification: "/Utilities/api/Notification/Notification/Read",
  };
  // Goal Types
  public static GoalTypes = {
    create: "/GoalEngine/api/GoalType/Create",
    update: "/GoalEngine/api/GoalType/Update",
    delete: "/GoalEngine/api/GoalType/Delete",
    updateEnable: "/GoalEngine/api/GoalType/Enable",
  };

  // Meetings
  public static meetings = {
    getStats: "/ServiceDesk/api/Meeting/GetStatitics",
    getAll: "/ServiceDesk/api/Meeting/View",
    getMyActions: "/ServiceDesk/api/Meeting/GetMyActions",
    getStatus: "/ServiceDesk/api/Meeting/GetStatus",
    save: "/ServiceDesk/api/Meeting/Save",
    saveAsDraft: "/ServiceDesk/api/Meeting/SaveDraft",
    delete: "/ServiceDesk/api/Meeting/Delete",
    copy: "/ServiceDesk/api/Meeting/CopyMinutesOfMeeting",
    submit: "/ServiceDesk/api/Meeting/Submit",
    exportPDF: "/ServiceDesk/api/Meeting/ExportPDF",
    exportExcel: "/ServiceDesk/api/Meeting/ExportExcel",
    GetCount: "/ServiceDesk/api/Meeting/GetCount",
    attendees: {
      create: "/ServiceDesk/api/Attendee/Create",
      update: "/ServiceDesk/api/Attendee/Update",
      get: "/ServiceDesk/api/Attendee/View",
      delete: "/ServiceDesk/api/Attendee/Delete",
      getAttendees: "/ServiceDesk/api/Attendee/Get",
    },
    discussionItems: {
      create: "/ServiceDesk/api/DiscussionItem/Create",
      update: "/ServiceDesk/api/DiscussionItem/Update",
      get: "/ServiceDesk/api/DiscussionItem/View",
      delete: "/ServiceDesk/api/DiscussionItem/Delete",
    },
    actionItems: {
      create: "/ServiceDesk/api/ActionItem/Create",
      update: "/ServiceDesk/api/ActionItem/Update",
      get: "/ServiceDesk/api/ActionItem/View",
      getById: "/ServiceDesk/api/ActionItem/Get",
      delete: "/ServiceDesk/api/ActionItem/Delete",
      getAll: "/ServiceDesk/api/ActionItem/Get/Meeting",
    },
  };
  public static delegations = {
    getAll: "/WorkflowEngine/api/Delegation/Search",
    get: "/WorkflowEngine/api/Delegation/Get",
    create: "/WorkflowEngine/api/Delegation/Add",
    cancel: "/WorkflowEngine/api/Delegation/Cancel",
    update: "/WorkflowEngine/api/Delegation/Update",
  };

  //FollowUp
  public static FollowUp = {
    Get: "/ServiceDesk/api/Followup/Get",
    GetMyHirerchy: "/ServiceDesk/api/User/GetMyHirerchy",
    UpdateProgress: "/ServiceDesk/api/ActionItem/UpdateProgress",
    GetActionItem: "/ServiceDesk/api/ActionItem/Get",
    Create: "/ServiceDesk/api/ActionItem/Create",
    Update: "/ServiceDesk/api/ActionItem/Update",
    closeTask: "/ServiceDesk/api/ActionItem/Close",
    ExportExcel: "/ServiceDesk/api/Followup/ExportExcel",
    reopenTask: "/ServiceDesk/api/ActionItem/Reopen",
    transferTask: "/ServiceDesk/api/ActionItem/Transfer",
    GetCount: "/ServiceDesk/api/Followup/GetCount",
    GetCardsCount: "/ServiceDesk/api/Followup/GetSummary",
    verifyTask: "/ServiceDesk/api/Followup/Verify",
    sendReminder: "/ServiceDesk/api/Followup/Reminder",
  };

  public static Projects = {
    ExportRequests: "/Eppm/api/Project/Request/Export",
    GetCount: "/Eppm/api/Project/Request/GetCount",
    GetApprovedCount: "/Eppm/api/Project/GetPendingCount",
    GetClosureRequestsCount: "/Eppm/api/Project/Closure/GetCount",
    AddExternalStakeholder: "/Eppm/api/Project/ExternalStakeholder/Add",
    RemoveExternalStakeholder: "/Eppm/api/Project/ExternalStakeholder/Remove",
    AddTeamMembers: "/Eppm/api/Project/TeamMembers/Update",
    GetChangeRequestsCount: "/Eppm/api/ChangeRequest/GetCount",
  };

  //SerServices & Requests - Dashboard
  public static servicesDashboard = {
    GetRequestsStatics: "/ServiceDesk/api/Dashboard/Requests/StatusStatistic",
    GetClosureRate: "/ServiceDesk/api/Dashboard/Requests/ClosureRate",
    GetCategoriesSLA: "/ServiceDesk/api/Dashboard/Requests/CategoriesSLAs",
    GetRequestsTrackingCharts:
      "/ServiceDesk/api/Dashboard/Requests/SLAStatistic",
    GetServicesDistributions:
      "/ServiceDesk/api/Dashboard/Requests/ServicesDistributions",

    //followUp
    GetFolloUpPerQuartar: "/ServiceDesk/api/Dashboard/FollowUps/PerQuarter",
    GetMeetingsPerQuartar: "/ServiceDesk/api/Dashboard/Meetings/PerQuarter",
    GetFollowUpTrackingChart:
      "/ServiceDesk/api/Dashboard/FollowUps/ProgressTracking",
    GetFollowUpItems: "/ServiceDesk/api/Dashboard/FollowUps/StatusStatistic",
    GetFollowUpClosureRate: "/ServiceDesk/api/Dashboard/FollowUps/ClosureRate",
    GetFollowUpLoadedEmp:
      "/ServiceDesk/api/Dashboard/FollowUps/TopLoadedEmployees",
    GetFollowUpMeetingsStatus:
      "/ServiceDesk/api/Dashboard/Meetings/StatusStatistic",
    GetFollowUpServicesTypes: "/ServiceDesk/api/Dashboard/FollowupsPerType",
  };

  // Committees
  public static CommitteesManagement = {
    GetAll: "/Committees/api/Committees/Get",
    GetList: "/Committees/api/Committees/GetList",
    GetApproved: "/Committees/api/Committees/GetApproved",
    GetCommittees: "/Committees/api/Committees/GetAll",
    GetCommitteeDetails: "/Committees/api/Committees/Get",
    GetStatus: "/Committees/api/Committees/GetStatus",
    GetActions: "/Committees/api/Committees/GetMyActions",
    SaveDraft: "/Committees/api/Committees/SaveDraft",
    Save: "/Committees/api/Committees/Save",
    SendRequest: "/Committees/api/Committees/SendRequest",
    DeleteRequest: "/Committees/api/Committees/Delete",
    GetUsers: "/Committees/api/Committees/Users/{id}",
    ExportDecision: "/Committees/api/Committees/ExportDecision",
    hasSuspendedRequests: "/Committees/api/ChangeRequest/hasSuspendedRequests",
    GetCRById: "/Committees/api/ChangeRequest/Get",
    GetCRDetails: "/Committees/api/ChangeRequest/Details",
    ExportCR: "Committees/api/ChangeRequest/ExportDecision",
    GetDecisionText: "/Committees/api/Committees/DecisionText",
    GetChangeRequestDecisionText: "/Committees/api/ChangeRequest/DecisionText",
    UsersAndExternalMember: "/Committees/api/Committees/UsersAndExternalMember",
    GetCount: "/Committees/api/Committees/GetCount",
    GetModifyRequestCount: "/Committees/api/ChangeRequest/GetCount",
    GetCommitteeRequestCount: "/Committees/api/Committees/GetCount",
    GetCommitteeTotalCount: "/Committees/api/Task/GetTotalCount",
    GetCommitteeDetailsMeetingCount:
      "/Committees/api/Committees/Get/Meetings/Count",
    GetCommitteeDetailsTaskCount: "/Committees/api/Committees/Get/Tasks/Count",
    GetCommitteeDetailsDecisionCount:
      "/Committees/api/Committees/Get/Decisions/Count",
    GetCommitteeDetailsKPICount: "/Committees/api/Committees/Get/KPI/Count",
    GetCommitteeDetailsEvaluationCount:
      "/Committees/api/Committees/Get/Observations/Count",
    verifyTask: "/Committees/api/Task/Verify",
  };
  public static CommitteeModifyRequests = {
    SaveDraft: "/Committees/api/ChangeRequest/SaveDraft",
    Save: "/Committees/api/ChangeRequest/Save",
    SendRequest: "/Committees/api/ChangeRequest/SendRequest",
  };
  public static CommitteeKpi = {
    GetAllByCommitteeId: "/Committees/api/CommitteeKpi/Get",
    GetById: "/Committees/api/CommitteeKpi/GetById",
    Create: "/Committees/api/CommitteeKpi/Create",
    Update: "/Committees/api/CommitteeKpi/Update",
    Delete: "/Committees/api/CommitteeKpi/Delete",
    UpdateProgress: "/Committees/api/CommitteeKpi/UpdateProgress",
    VerifyResult: "/Committees/api/CommitteeKpi/VerifyResult",
    ExportExcel: "/Committees/api/CommitteeKpi/Export",
  };

  public static committeeMembers = {
    GetCommitteeMembers: "/Committees/api/Committees/GetCommitteeMembers",
    GetExternalMemberById: "/Committees/api/Committees/GetExtrernalMember",
  };

  //committee evaluations

  public static CommitteeEvaluations = {
    GetAll: "/Committees/api/Audit/ViewAll",
    GetAudit: "/Committees/api/Audit/View",
    GetDetails: "/Committees/api/Audit/Details",
    ExportExcel: "/Committees/api/Audit/Export",
    Add: "/Committees/api/Audit/Add",
    Cancel: "/Committees/api/Audit/Cancel",
    CloseAndApprove: "/Committees/api/Audit/Close",
    Update: "/Committees/api/Audit/Update",
    membersPerformance: "/Committees/api/AuditDashboard/MemberPerformance",
  };

  public static EvaluationStatics = {
    Statistics: "/Committees/api/AuditDashboard/Statistics",
    Meetings: "/Committees/api/AuditDashboard/MeetingStatistics",
    KPIs: "/Committees/api/AuditDashboard/KpiStatistics",
    Tasks: "/Committees/api/AuditDashboard/MainTaskStatistics",
    ClosedStatistics: "/Committees/api/AuditDashboard/CloseStatistics",
  };
  public static CommitteeObservations = {
    Create: "/Committees/api/AuditObservation/Add",
    Close: "/Committees/api/AuditObservation/Close",
    Reopen: "/Committees/api/AuditObservation/Reopen",
    GetComments: "/Committees/api/AuditObservation/GetComments",
    AddComment: "/Committees/api/AuditObservation/Comment",
    DeleteComment: "/Committees/api/AuditObservation/DeleteComment",
  };
  public static CommitteeMainTask = {
    GetAllByCommitteeId: "/Committees/api/task/Get",
    GetById: "/Committees/api/MainTask/GetById",
  };

  //Work Groups
  public static WorkGroup = {
    Create: "/Committees/api/Workgroup/Create",
    Update: "/Committees/api/Workgroup/Update",
    GetAllByCommitteeId: "/Committees/api/Workgroup/Get",
    GetListByCommitteeId: "/Committees/api/Workgroup/Get/List",
    GetGroupDetails: "/Committees/api/Workgroup/Get/Id",
    ChangeStatus: "/Committees/api/Workgroup/ChangeStatus",
    GetgroupsNames: "/Committees/api/Workgroup/WorkgroupNames/",
  };

  // Decision
  public static Decision = {
    SaveDraft: "/Committees/api/Decision/SaveDraft",
    GetAllByCommitteeId: "/Committees/api/Decision/Get",
    GetById: "/Committees/api/Decision/Get/Id",
    GetInstanceId: "/Committees/api/Decision/Get/StatusDetails",
    Publish: "/Committees/api/Decision/Publish",
    Vote: "/Committees/api/Decision/Vote",
    ExportPDF: "/Committees/api/Decision/ExportPDF",
    GetMeeting: "/Committees/api/Decision/Get/Meeting",
    Send: "/Committees/api/Decision/Send",
    MessageHistory: "/Committees/api/Decision/MessageHistory",
    VotingHistory: "/Committees/api/Decision/VotingHistory",
    Confirm: "/Committees/api/Decision/Confirm",
  };

  //Meetings
  public static Meeting = {
    GetAllByCommitteeId: "/Committees/api/Meeting/Get",
    GetById: "/Committees/api/Meeting/Get/Id",
    SaveDraft: "/Committees/api/Meeting/SaveDraft",
    Publish: "/Committees/api/Meeting/Publish",
    SaveMom: "/Committees//api/Meeting/SaveMom",
    PublishForReview: "/Committees/api/Meeting/PublishForReview",
    ExportPDF: "Committees/api/Meeting/ExportPDF",
    GetWorkflowHistory: "/Committees/api/Meeting/GetHistory",
    Attendees: {
      Add: "/Committees/api/MeetingAttendee/Add",
      Update: "/Committees/api/MeetingAttendee/Update",
      GetAllByMeetingId: "/Committees/api/MeetingAttendee/Get",
      GetById: "/Committees/api/MeetingAttendee/Get/Id",
    },
    Comments: {
      GetByMeetingId: "/Committees/api/MeetingComment/Get/Meeting",
      Add: "/Committees/api/MeetingComment/Create",
      GetById: "/Committees/api/MeetingComment/Get/id",
    },
  };

  // Task
  public static Task = {
    GetAllByCommitteeId: "/Committees/api/Task/Get",
    GetById: "/Committees/api/Task/Get/Id",
    Create: "/Committees/api/Task/Create",
    Update: "/Committees/api/Task/Update",
    Delete: "/Committees/api/Task/Delete",
    GetMeeting: "/Committees/api/Task/Get/Meeting",
    GetByWorkGroupId: "/Committees/api/Task/Get/WorkGroup",
    ChangeStatus: "/Committees/api/Task/ChangeStatus",
    UpdateProgress: "/Committees/api/Task/UpdateProgress",
    ExportExcel: "/Committees/api/Task/ExportExcel",
    GetHistory: "/Committees/api/Task/GetHistory",
    GetFiles: "/Committees/api/Task/GetFiles",
    Comment: {
      Create: "/Committees/api/TaskComment/Create",
    },
  };
  public static DiscussionItem = {
    GetById: "/Committees/api/DiscussionItem/Get/Id",
    Create: "/Committees/api/DiscussionItem/Create",
    Update: "/Committees/api/DiscussionItem/Update",
    GetMeeting: "/Committees/api/DiscussionItem/Get/Meeting",
  };

  // VotingTemplate
  public static VotingTemplate = {
    Get: "/Committees/api/VotingTemplate/Get",
    GetById: "/Committees/api/VotingTemplate/Get",
    Create: "/Committees/api/VotingTemplate/Create",
    Update: "/Committees/api/VotingTemplate/Update",
    Delete: "/Committees/api/VotingTemplate/Delete",
  };

  // weight settings
  public static WeightSettings = {
    Get: "/Committees/api/WeightSettings/GetFirst",
    Update: "/Committees/api/WeightSettings/Update",
  };

  // sponsporship settings
  public static sponsporshipSettings = {
    GetList: "/Committees/api/CommitteeSponsors/GetList",
    Save: "/Committees/api/CommitteeSponsors/Save",
  };

  // Event
  public static Event = {
    GetAll: "/EventService/api/admin/event/list",
    GetById: "/EventService/api/Admin/event/details",
    Create: "/EventService/api/Event/Add",
    Update: "/EventService/api/Event/Update",
    Cancel: "/SSEM/api/Event/Cancel",
    // Delete: "/SSEM/api/Event/Delete",
    Delete: "/EventService/api/Event",
    DeleteAttendee: "/SSEM/api/Event/Attendee/Delete",
    Rating: "/SSEM/api/Event/Attendee/Rating",
    CloseRating: "/SSEM/api/Event/Attendee/CloseRating",
    Registration: "/SSEM/api/Event/Registration",
    LoopUps: "/EventService/api/Lookup/event-lookups",
    EventStatusLookup: "/EventService/api/Lookup/event-status",
    AttendeeStatusLookup: "/EventService/api/Lookup/attendee-status",
    coordinators: "/EventService/api/Lookup/coordinator",
    organizations: "/EventService/api/lookup/my/organizations",
    recurrings: "/EventService/api/admin/event/filter-light",
    Statistics: "/EventService/api/Event/Statistics",
    PublishEvent: "/EventService/api/admin/event/publish",
    SendInvitations: "/EventService/api/admin/event/share",
    GetAttendees: "/EventService/api/admin/attendee/list",
    AdminAttendeeCheckIn: "/EventService/api/admin/attendee/check-in",
    AdminAttendeeUndoCheckIn: "/EventService/api/admin/attendee/undo-check-in",
    AdminAttendeeCheckOut: "/EventService/api/admin/attendee/check-out",
    AdminAttendeeUndoCheckOut:
      "/EventService/api/admin/attendee/undo-check-out",
    GetEventActionsLogs: "/EventService/api/Event/flow-actions-logs",
    GetAttendeeActionsLogs: "/EventService/api/Attendee/flow-actions-logs",
    GetRegistrationById: "/EventService/api/public/attendee/qr-scan-details",
    CheckIn: "/EventService/api/public/attendee/check-in",
    CheckOut: "/EventService/api/public/attendee/check-out",
    GetUpdateRequests: "/EventService/api/admin/event/update-requests/list",
    GetUpdateRequestById:
      "/EventService/api/admin/event/update-requests/details",
    SendCertificates: "/EventService/api/admin/event/certifications/generate",
    GetEventsByStatus:
      "/EventService/api/admin/event/dashboard/events-by-status",
    GetEventsByType: "/EventService/api/admin/event/dashboard/events-by-type",
    GetEventsSummaryKpis:
      "/EventService/api/admin/event/dashboard/events-summary-kpis",
    GetEventsAttendeeStatistics:
      "/EventService/api/admin/event/dashboard/attendee-statistics",
    GetEventsUpcomingEvents:
      "/EventService/api/admin/event/dashboard/upcoming-events",
    GetEventsApprovalQueue:
      "/EventService/api/admin/event/dashboard/approval-queue",
  };

  // Jobs
  public static Job = {
    GetAll: "/CareersAndVolunteers/api/admin/careers/jobs/list",
    LookUps: "/CareersAndVolunteers/api/admin/careers/jobs/lookups",
    CreateJob: "/CareersAndVolunteers/api/admin/careers/jobs/add",
    UpdateJob: "/CareersAndVolunteers/api/admin/careers/jobs/update",
    GetJobById: "/CareersAndVolunteers/api/admin/careers/jobs/details",
    GetJobApplicationsList:
      "/CareersAndVolunteers/api/admin/careers/job-applications/list",
    GetApplicationDetails:
      "/CareersAndVolunteers/api/admin/careers/job-applications/details",
    ReOpenJob: "/CareersAndVolunteers/api/admin/careers/jobs/re-open",
    CloseJob: "/CareersAndVolunteers/api/admin/careers/jobs/close",
    ApproveApplication:
      "/CareersAndVolunteers/api/admin/careers/job-applications/fit",
    RejectApplication:
      "/CareersAndVolunteers/api/admin/careers/job-applications/un-fit",
    ScheduleInterview:
      "/CareersAndVolunteers/api/admin/careers/job-applications/schedule-interview",
    GetJobLogs: "/CareersAndVolunteers/api/admin/careers/jobs/logs",
    GetInterviewLogs:
      "/CareersAndVolunteers/api/admin/careers/job-applications/schedule-interview/list",
    // Dashboard APIs
    GetJobStatistics:
      "/CareersAndVolunteers/api/admin/careers/jobs/dashboard/get-statistics",
    GetJobApplicantChart:
      "/CareersAndVolunteers/api/admin/careers/jobs/dashboard/get-applicant-chart",
    GetJobOpportunities:
      "/CareersAndVolunteers/api/admin/careers/jobs/dashboard/get-job-opportunities",
    GetJobOpportunitiesList:
      "/CareersAndVolunteers/api/admin/careers/jobs/dashboard/get-job-opportunities/list",
    GetOrganizations:
      "/CareersAndVolunteers/api/careers/lookups/my/organizations",
  };

  public static Membership = {
    GetAllRequests: "/Membership/api/admin/memberships/requests/list",
    GetRequestById: "/Membership/api/admin/memberships/requests/details",
    LookUps: "/Membership/api/public/lookups",
    OrganizationsLookUps: "/Membership/api/lookups",
    getAllEntities: "/HHEO/api/Organization/GetList/",
    ApproveRequest: "/Membership/api/admin/memberships/requests/approve",
    RejectRequest: "/Membership/api/admin/memberships/requests/reject",
    RequestPayment:
      "/Membership/api/admin/memberships/requests/request-payment",
    TransferMember: "/Membership/api/admin/members/transfer/initiate",
  };

  // membership packages
  public static MembershipPackages = {
    GetAll: "/Membership/api/admin/memberships/packages/list",
    GetById: "/Membership/api/admin/memberships/packages/details",
    CreatePackage: "/Membership/api/admin/memberships/packages/add",
    UpdatePackage: "/Membership/api/admin/memberships/packages/update",
    Activate: "/Membership/api/admin/memberships/packages/activate",
    Deactivate: "/Membership/api/admin/memberships/packages/deactivate",
    Delete: "/Membership/api/admin/memberships/packages/delete",
    GetPackageTypes: "/Membership/api/public/lookups/package-type", // Packages types list
    GetStatusTypes: "/Membership/api/lookups/package-status",
    GetDurations: "/Membership/api/public/lookups/durations",
    GetTargetAudience: "/Membership/api/public/lookups/Target-Audience",
    GetTargetGenders: "/Membership/api/public/lookups/target-gender",
    GetOrganizations: "/Membership/api/lookups/my/organizations",
  };

  // Members
  public static Member = {
    GetActiveMembers: "/Membership/api/admin/members/management/list/active",
    GetInActiveMembers:
      "/Membership/api/admin/members/management/list/inactive",
    SendEmail: "/Membership/api/admin/members/management/send-email",
    sendNotificationEmail:
      "/Membership/api/admin/members/management/payment/send-reminder-email",
    Deactivate: "/Membership/api/admin/members/management/deactivate",
    Activate: "/Membership/api/admin/members/management/activate",
    GetMemberDetailsById: "/Membership/api/admin/members/management/details", // for tabs
    GetMemberInformationTabById:
      "/Membership/api/admin/members/management/membership/details", // for information tab
    GetPaymentInfo:
      "/Membership/api/admin/members/management/payment/transactions",
    GetDuePayments: "/Membership/api/admin/members/management/payment/duo-list",
  };

  // Membership Management
  public static MembershipManagement = {
    GetActiveMemberships:
      "/Membership/api/admin/memberships/management/list/active",
    GetExpiredMemberships:
      "/Membership/api/admin/memberships/management/list/expired",
    GetCancelledMemberships:
      "/Membership/api/admin/memberships/management/list/cancelled",
    GetMembershipById: "/Membership/api/admin/memberships/management/details",
    UpgradeMembership: "/Membership/api/admin/memberships/management/upgrade",
    RenewMembership: "/Membership/api/admin/memberships/management/renew",
    CancelMembership: "/Membership/api/admin/memberships/management/cancel",
    DowngradeMembership:
      "/Membership/api/admin/memberships/management/downgrade",
    ReactivateMembership:
      "/Membership/api/admin/memberships/management/reactivate",
    GetSupportedPackages: "/Membership/api/lookups/packages",
    SelectNewPackage: "/Membership/api/admin/memberships/management",
    UpdateCenter: "/Membership/api/admin/memberships/management/update-center",
    UpdatePersonalPhoto:
      "/Membership/api/admin/memberships/management/update-personal-photo",
    UpdateHealthCheck:
      "/Membership/api/admin/memberships/management/update-health-check",
    SuspendMembership: "/Membership/api/memberships",
    ExtendSuspension: "/Membership/api/admin/membership-suspensions/requests",
    UpdateSuspension: "/Membership/api/admin/membership-suspensions/requests",
    GetCenterHistory:
      "/Membership/api/admin/memberships/management/get-center-history",
  };

  // Membership Transfer Requests
  public static MembershipTransferRequests = {
    GetNewTransferRequests:
      "/Membership/api/admin/members/transfer/requests/new",
    GetApprovedTransferRequests:
      "/Membership/api/admin/members/transfer/requests/approved",
    GetRejectedTransferRequests:
      "/Membership/api/admin/members/transfer/requests/rejected",
    GetById: "/Membership/api/admin/members/transfer/requests/details",
    Approve: "/Membership/api/admin/members/transfer/approve",
    Reject: "/Membership/api/admin/members/transfer/reject",
    Cancel: "/Membership/api/admin/members/transfer/cancel",
  };
  //Booking
  public static Booking = {
    getList: "/Booking/api/admin/assets/list/",
    getAssetTypes: "/Booking/api/lookups/asset-types/",
    getCapacityUnits: "/Booking/api/lookups/capacity-units/",
    getAvailabilityTypes: "/Booking/api/lookups/availability-types",
    addNewAsset: "/Booking/api/admin/assets/create",
    updateAsset: "/Booking/api/admin/assets/update",
    getAssetById: "/Booking/api/admin/assets/details",
    getAssetLogsById: "/Booking/api/admin/assets/update-logs",
    getBookingRequestById: "/Booking/api/admin/booking/details",
    getBookingUpdateCancelById:
      "/Booking/api/admin/booking/details/update-request",
    getNewBookingList: "/Booking/api/admin/booking/list",
    getUpdateBookingRequests: "/Booking/api/admin/booking/list/update-requests",
    getCancelBookingRequests: "/Booking/api/admin/booking/list/cancel-requests",
    activateAsset: "/Booking/api/admin/assets/activate",
    setDynamicPrice: "/Booking/api/admin/booking/set-price",
    deactivateAsset: "/Booking/api/admin/assets/deactivate",
    deleteAsset: "/Booking/api/admin/assets/delete",
    assetsStatuses: "/Booking/api/lookups/asset-status",
  };
  // Volunteers
  public static Volunteer = {
    GetAll: "/CareersAndVolunteers/api/admin/volunteers/list",
    GetByID: "/CareersAndVolunteers/api/admin/volunteers/details",
    Create: "/CareersAndVolunteers/api/admin/volunteers/add",
    Update: "/CareersAndVolunteers/api/admin/volunteers/update",
    LookUps: "/CareersAndVolunteers/api/admin/volunteers/lookups",
    ReopenOpportunity: "/CareersAndVolunteers/api/admin/volunteers/re-open",
    CloseOpportunity: "/CareersAndVolunteers/api/admin/volunteers/close",
    GetVolunteersApplicationsList:
      "/CareersAndVolunteers/api/admin/volunteers/volunteer-applications/list",
    GetApplicationDetails:
      "/CareersAndVolunteers/api/admin/volunteers/volunteer-applications/details",
    ApproveApplication:
      "/CareersAndVolunteers/api/admin/volunteers/volunteer-applications/fit",
    RejectApplication:
      "/CareersAndVolunteers/api/admin/volunteers/volunteer-applications/un-fit",
  };

  // Competitions
  public static Competition = {
    GetCompetitionsList: "/Competitions/api/admin/Competitions/list",
    GetUpdateCompetitionsList:
      "/Competitions/api/admin/competitions/update-requests/list",
    GetCompetitionDetails: "/Competitions/api/admin/Competitions/details",
    GetCompetitionUpdateDetails:
      "/Competitions/api/admin/competitions/update-requests/details",
    CreateCompetition: "/Competitions/api/admin/Competitions/create",
    UpdateCompetition: "/Competitions/api/admin/Competitions/update",
    GetCompetitionTypesLookup:
      "/Competitions/api/public/lookups/competition-type",
    GetCompetitionActionsLogs:
      "/Competitions/api/admin/competitions/update-logs",
    GetCompetitionStatusLookup:
      "/Competitions/api/public/lookups/competition-status",
    GetOrganizationsLookup: "/EventService/api/lookup/my/organizations",
    getJudgesLookup: "/Competitions/api/public/lookups/judge-status",
    GetCoordinatorUsersLookup: "/UserManagement/api/my/coordinators", // TODO: to be changed
    GetEligibilityCriteriasLookup:
      "/Competitions/api/public/lookups/eligibility-criterias",
    GetTargetAudiencesLookup:
      "/Competitions/api/public/lookups/target-audience",
    GetApplicationStatusLookup:
      "/Competitions/api/public/lookups/application-status",
    GetPrizesLookup: "/Competitions/api/public/lookups/prizes",
    GetSkillsLookup: "/Competitions/api/public/lookups/skills",
    GetParticipantById:
      "/Competitions/api/admin/competitions/participant-request-details",
    //participants
    GetParticipantsList:
      "/Competitions/api/admin/competitions/applications-list",
    GetEvaluateParticipantsList:
      "/Competitions/api/admin/competitions/application-evaluate-list",
    GetEvaluationById: "/Competitions/api/admin/competitions/view-evaluate",
    GetPrizeById: "/Competitions/api/admin/competitions/view-assign-prize",
    GetResultingParticipantsList:
      "/Competitions/api/admin/competitions/participant-progress-list",
    ApproveApplication:
      "/Competitions/api/admin/competitions/approve-application",
    RejectApplication:
      "/Competitions/api/admin/competitions/reject-application",
    EvaluateApplication: "/Competitions/api/admin/competitions/submit-evaluate",
    SubmitPrize: "/Competitions/api/admin/competitions/assign-prize",
    downloadBulkTemplate:
      "/Competitions/api/admin/competitions/bulk-register-download-url",
    bulkRegister: "/Competitions/api/admin/competitions/bulk-register",
    RejectCompetition: "/Competitions/api/admin/competitions/reject",
    RejectUpdateCompetition:
      "/Competitions/api/admin/competitions/update-requests/reject",
    ReturnForCorrection:
      "/Competitions/api/admin/competitions/return-for-correction",
    ApproveCompetition: "/Competitions/api/admin/competitions/approve",
    ApproveUpdateCompetition:
      "/Competitions/api/admin/competitions/update-requests/approve",
    deleteCompetition:
      "/Competitions/api/admin/competitions/delete-competition",
    deleteEvaluation:
      "/Competitions/api/admin/competitions/delete-evalution-criteria",
    switchEvaluationStatus:
      "/Competitions/api/admin/competitions/active-deActive-evalution-criteria",
    GetRejectReasons: "/Competitions/api/public/lookups/reject-reason",
    submitEvaluations:
      "/Competitions/api/admin/competitions/submit-evaluations",
    assignPrizes: "/Competitions/api/admin/competitions/submit-assign-prizes",
  };

  // Competitions
  public static NewCompetition = {
    Base: "/Competitions/api/SheikhSultanCompetitions",
    CreateCompetition: `/Competitions/api/SheikhSultanCompetitions/CreateCompetition`,
    UpdateCompetition: `/Competitions/api/SheikhSultanCompetitions/UpdateCompetition`,
    DeleteCompetition: `/Competitions/api/SheikhSultanCompetitions/DeleteCompetition`,
    GetCompetitionById: `/Competitions/api/SheikhSultanCompetitions/GetCompetitionById`,
    GetParticipantsList:
      "/Competitions/api/SheikhSultanCompetitions/applications-list",
    GetParticipantById: "/Competitions/api/wizard/GetAdminApplicationsDetails",
    GetAllCompetitions: `/Competitions/api/SheikhSultanCompetitions/GetAllCompetitions`,
    GetAllWinners: "/Competitions/api/admin/ceremony-invites/GetAllWinnerAsync",
    GeneratingWinnerReport: "/Competitions/api/admin/ceremony-invites/GeneratingWinnerReport",
    GetWinnerByID:
      "/Competitions/api/admin/ceremony-invites/GetWinnerByIdAsync",
    CreateCeremonyInvite:
      "/Competitions/api/admin/ceremony-invites/CreateCeremonyInvite",
    SendToWinners: "/Competitions/api/admin/ceremony-invites/SendToWinners",
    GetWinnersReport: "/Competitions/api/admin/Winner-Report/GetWinnersReport",
    GetSchools: "/Competitions/api/SheikhSultanAwardLookups/GetSchools",
    CoordinatorApprove: "/Competitions/api/review/coordinator/approve",
    CoordinatorReject: "/Competitions/api/review/coordinator/reject",
    JudgeApprove: "/Competitions/api/review/judge/approve",
    JudgeReject: "/Competitions/api/review/judge/reject",
    AdminApprove: "/Competitions/api/review/audit/approve",
    AdminReject: "/Competitions/api/review/audit/reject",
    CoordinatorReturn: "/Competitions/api/review/coordinator/more-info",
    JudgeReturn: "/Competitions/api/review/judge/more-info",
    AdminReturn: "/Competitions/api/review/audit/more-info",
    AssignOrganizationCoordinator:"/Competitions/api/organization-coordinator/assign",
    GetAllAssignedOrganizations: "/Competitions/api/organization-coordinator/GetAllAssignedOrganizations",
    GetSheikhSultanCoordinators: "/Competitions/api/organization-coordinator/GetSheikhSultanCoordinators",
    GetOrganizations: "/Competitions/api/SheikhSultanAwardLookups/GetOrganizations",
    GetBackendOrganizations: "/Competitions/api/SheikhSultanAwardLookups/backend-organizations",
    SendRatingEmails: "/Competitions/api/admin/ceremony-invites/SendRatingEmail",
    GetRejectionReasons: "/Competitions/api/SheikhSultanAwardLookups/application-reject-reason",
    UpdateApplication: "/Competitions/api/admin/update-application",
  };

  // MediaCenter
  public static MediaCenter = {
    GetPressReleases: "/Utilities/api/admin/press-releases/list",
    GetPressReleaseById: "/Utilities/api/admin/press-releases/details",
    GetPressReleaseCategories:
      "/Utilities/api/admin/press-releases/categories/list",
    AddPressRelease: "/Utilities/api/admin/press-releases/create",
    UpdatePressRelease: "/Utilities/api/admin/press-releases/update",
    AddPressReleaseCategory:
      "/Utilities/api/admin/press-releases/categories/create",
    UpdatePressReleaseCategory:
      "/Utilities/api/admin/press-releases/categories/update",
    DeletePressReleaseCategory:
      "/Utilities/api/admin/press-releases/categories/delete",
    DeletePressRelease: "/Utilities/api/admin/press-releases/delete",

    GetAlbums: "/Utilities/api/admin/media-center/albums/list",
    GetAlbumById: "/Utilities/api/admin/media-center/album/details",
    AddAlbum: "/Utilities/api/admin/media-center/albums/create",
    UpdateAlbum: "/Utilities/api/admin/media-center/albums/update",
    DeleteAlbum: "/Utilities/api/admin/media-center/albums/delete",
    GetAlbumCategories:
      "/Utilities/api/admin/media-center/albums/categories/list",
    AddAlbumCategory:
      "/Utilities/api/admin/media-center/albums/categories/create",
    UpdateAlbumCategory:
      "/Utilities/api/admin/media-center/albums/categories/update",
    DeleteAlbumCategory:
      "/Utilities/api/admin/media-center/albums/categories/delete",

    GetVideos: "/Utilities/api/admin/media-center/videos/list",
    GetVideoById: "/Utilities/api/admin/media-center/videos/details",
    DeleteVideo: "/Utilities/api/admin/media-center/videos/delete",
    AddVideo: "/Utilities/api/admin/media-center/videos/create",
    UpdateVideo: "/Utilities/api/admin/media-center/videos/update",
    GetVideoCategories:
      "/Utilities/api/admin/media-center/videos/categories/list",
    AddVideoCategory:
      "/Utilities/api/admin/media-center/videos/categories/create",
    UpdateVideoCategory:
      "/Utilities/api/admin/media-center/videos/categories/update",
    DeleteVideoCategory:
      "/Utilities/api/admin/media-center/videos/categories/delete",
    AddImageToAlbum: "/Utilities/api/admin/media-center/album-items/create",
    GetAlbumImagesByAlbumId: "/Utilities/api/admin/media-center/album/items",
    DeleteImage: "/Utilities/api/admin/media-center/album-items/delete",
    GetPressReleaseList: "/Utilities/api/admin/press-releases/list/search",
  };

  // WorkflowEngine
  public static WorkflowEngine = {
    getProcessesByIds: "/WorkflowEngine/api/Process/GetProcessesByIds",
    // new APIs
    GetTask: "/WorkflowEngine/api/Task/Instance/Get",
    GetInstance: "/WorkflowEngine/api/Instance/Get",
    GetStates: "/WorkflowEngine/api/instance/States",
    Reassign: "/WorkflowEngine/api/Task/Reassign",
    ReassignCancel: "/WorkflowEngine/api/Task/Reassign/Cancel",
    Perform: "/WorkflowEngine/api/Action/Perform",
    Override: "/WorkflowEngine/api/Action/Force/Perform",
    PerformCancel: "/WorkflowEngine/api/Action/Cancel/Perform",
  };

  // Process
  public static Process = {
    GetAll: "/WorkflowEngine/api/Process/Search",
    Add: "/WorkflowEngine/api/Process/Add",
    Update: "/WorkflowEngine/api/Process/Update",
    Get: "/WorkflowEngine/api/Process/Get",
    Delete: "/WorkflowEngine/api/Process/ToggleActivation",
    ToggleEnable: "/WorkflowEngine/api/Process/ToggleEnable",
    ValidateTitle: "/WorkflowEngine/api/Process/ValidateTitle",
  };

  public static States = {
    Add: "/WorkflowEngine/api/State/Add",
    update: "/WorkflowEngine/api/State/Update",
    delete: "/WorkflowEngine/api/State/Delete",
  };

  public static CommitteeDashboard = {
    GetMyStatistics: "/Committees/api/Dashboard/MyStatistics",
    GetTasksStatuses: "/Committees/api/Dashboard/TaskStatus",
    GetUpComingMeetingToday: "/Committees/api/Dashboard/UpComingMeetingToday",
    GetActiveTwoTasks: "/Committees/api/Dashboard/ActiveTwoTasks",
    GetLatestFourDecisions: "/Committees/api/Dashboard/LatestFourDecision",
    GetActivePolls: "/Committees/api/Dashboard/ActivePolls",
    GetRecentActivities: "/Committees/api/Dashboard/RecentActivities",
    GetAttendanceRate: "/Committees/api/Dashboard/AttendanceRate",
  };

  public static committeesDashboard = {
    GetCommitteesTypes: "/Committees/api/Dashboard/CommitteesPerType",
    GetCommitteesCategories: "/Committees/api/Dashboard/CommitteesPerCategory",
    GetCommitteesCount: "/Committees/api/Dashboard/TotalCommitteesCount",
    GetTotalMeetingsCount: "/Committees/api/Dashboard/TotalMeetingsCount",
    GetTotalDecisionsCount: "/Committees/api/Dashboard/TotalDecisionsCount",
    GetTotalTasksCount: "/Committees/api/Dashboard/TotalMainTasksCount",
    GetCommitteesAudits: "/Committees/api/Dashboard/CommitteeAudits",
    GetActiveStatuses: "/Committees/api/Dashboard/CommitteeActivityStatus",
    GetCommitteesTags: "/Committees/api/Committees/Get/Tags",
    ExportExcel: "/Committees/api/Dashboard/ExportExcel/CommitteeAudits",
  };

  public static Innovation = {
    Workflow: {
      Perform: "/Innovation/API/workflow/perform",
    },
    dashboard: {
      GetPeriods: "/Innovation/api/Dashboard/Periods/Get",
      GetIdeaReport: "/Innovation/api/Dashboard/IdeaReport/Get",
      GetEmployeesBadge:
        "/Innovation/api/Dashboard/IdeaReport/GetEmployeesBadge",
      ExternalStakeholderCategory:
        "/Innovation/api/Dashboard/IdeaReport/ExternalStakeholderCategory/Report",
      ActiveUsersReport: "/Innovation/api/Dashboard/Periods/ActiveUsersReport",
      GetUnitCollaboration:
        "/Innovation/api/Dashboard/IdeaReport/UnitCollaboration/Get",
      GetUnitHeatMap: "/Innovation/api/Dashboard/IdeaReport/UnitHeatmap/Get",
      GetBudget: "/Innovation/api/Dashboard/IdeaReport/Budget",
      Digest: "/Innovation/api/Dashboard/Dashbaord/Digest",
    },
    challenge: {
      add: "/Innovation/api/Challenge/Add",
      list: "/Innovation/api/Challenge/Search",
      analytics: "/Innovation/api/Challenge/Analytics",
      usersList: "/Innovation/api/Challenge/Analytics",
      GetAll: "/Innovation/api/Challenge/GetAll",
    },
    FocusArea: {
      GetAll: "/Innovation/api/FocusArea/GetAll",
    },

    Idea: {
      IdeaOrigins: "/Innovation/api/IdeaOrigin/GetAll",
      Save: "/Innovation/api/Idea/Save",
      GetMyIdeas: "/Innovation/api/Idea/GetMyIdeas",
      GetMyStatistics: "/Innovation/api/Idea/Get/MyStatistics",
      About: "/Innovation/api/Idea/About",
      ChangeGroup: "/Innovation/api/Idea/ChangeGroup",
      Update: "",
      Delete: "/Innovation/api/Idea/Delete",
      Details: "/Innovation/api/Idea/GetById",
      SaveAnalysis: "/Innovation/api/Idea/SaveAnalysis",
      SaveResources: "",
      GetAboutCreator: "/Innovation/api/Idea/AboutCreator/",
      SaveProtoType: "/Innovation/api/Idea/Prototye/Save",
      ProtoTypeGet: "/Innovation/api/Idea/Prototype/Get",
      GetAnalysis: "/Innovation/api/Idea/GetAnalysisById",
      UpdateResources: "/Innovation/api/Idea/Resources/Update",
      GetResources: "/Innovation/api/Idea/Resources/Get",
      Comment: "/Innovation/api/Idea/Idea/:id/Comment/Add",
      GetComments: "/Innovation/api/Idea/Idea/:id/Comment/GetAll",
      GetYears: "/Innovation/api/Idea/Years",
      BestInnovators: "/Innovation/api/InnovatorUser/BestInnovators",
      Evaluation: {
        Submit: "",
        Score: "/Innovation/api/Idea/UpdateScore",
        Get: "/Innovation/api/Idea/GetEvaluations",
      },
      Discussion: {
        AddComment: "",
      },
      Pilot: {
        GetPilots: "/Innovation/api/Idea/GetPilots",
        UpdateScore: "/Innovation/api/Idea/Pilot/UpdateScore",
        UpdatePilotInfo: "/Innovation/api/Idea/UpdatePilotInfo",
        GetPilotById: "/Innovation/api/Idea/GetPilotById/",
      },
      Invoice: {
        GetAll: "/Innovation/api/Idea/Invoices",
        GetById: "/Innovation/api/Idea/Invoice",
        Create: "/Innovation/api/Idea/Invoice/Create",
        Update: "/Innovation/api/Idea/Invoice/Update",
        Delete: "/Innovation/api/Idea/Invoice/Delete",
      },
      Risk: {
        GetAll: "/Innovation/api/Idea/Risk/GetAll",
        Create: "/Innovation/api/Idea/Risk/Create",
        Update: "/Innovation/api/Idea/Risk/Update",
        Delete: "/Innovation/api/Idea/Risk/Delete",
      },
    },
    assessment: {
      getAll: "/Innovation/api/Idea/Get/Assessments",
      getStatistics: "/Innovation/api/Idea/Get/Statistics",
    },
    ideaTeams: {
      getAllSelectedIdeas: "/Innovation/api/Idea/Team/Get",
      addSupportMember: "/Innovation/api/Idea/Team/SupportMember/Add",
      editSupportMember: "/Innovation/api/Idea/Team/SupportMember/Update",
      deleteSupportMember: "/Innovation/api/Idea/Team/SupportMember/Delete",
      addStackHolders: "/Innovation/api/Idea/Team/ExternalStakeholder/Add",
      editStackHolders: "/Innovation/api/Idea/Team/ExternalStakeholder/Update",
      deleteStackHolders:
        "/Innovation/api/Idea/Team/ExternalStakeholder/Delete",
      editLead: "/Innovation/api/Idea/Team/UpdateLead",
      addDepartment: "/Innovation/api/Idea/ChangeGroup",
    },
    selectedIdeas: {
      getAllSelectedIdeas: "/Innovation/api/Idea/Get/SelectedItems",
    },
    Lookup: {
      Horizons: "/Innovation/api/Lookup/Horizons/GetAll",
      AnalysisMethod: "/Innovation/api/AnalysisMethod/GetAll",
      IdeaBeneficiary: "/Innovation/api/IdeaBeneficiary/GetAll",
      InnovationCategories:
        "/Innovation/api/Lookup/InnovationCategories/GetAll",
      ProtoTypeCategories: "/Innovation/api/Lookup/Prototype/GetCategories",
      HappinessRatings: "/Innovation/api/Lookup/HappinessRatings/GetAll",
      EntityCategories:
        "/Innovation/api/Lookup/ExternalStakeholder/EntityCategories",
    },
    SystemResource: {
      Get: "/Innovation/api/SystemResource/Get",
      GetById: "/Innovation/api/SystemResource/Get/",
      Create: "/Innovation/api/SystemResource/Create",
      Update: "/Innovation/api/SystemResource/Update",
      Delete: "/Innovation/api/SystemResource/Delete/",
      GetCategories: "/Innovation/api/Lookup/SystemResource/GetCategories",
    },
    innovationFeed: {
      GetList: "/Innovation/api/InnovationFeed/Get",
    },
    resources: {
      hubList: {
        getAll: "/Innovation/api/SystemResource/Get/Hub",
      },
    },
    rewardCustomization: {
      achievementTires:
        "/Innovation/api/RewardConfiguration/AchievementTier/Get",
      GetTierById: "/Innovation/api/RewardConfiguration/AchievementTier/Get/",
      UpdateTier: "/Innovation/api/RewardConfiguration/AchievementTier/Update",
      CreateTier: "/Innovation/api/RewardConfiguration/AchievementTier/Create",
      rewardedAction: "/Innovation/api/RewardConfiguration/RewardedAction/Get",
      UpdateActions: "/Innovation/api/RewardConfiguration/Actions/Update",
      rewardedStatus:
        "/Innovation/api/RewardConfiguration/ChangeStatus/Id/{id}/Status/{status}",
    },
    projectSummary: {
      getSummary: "/Eppm/api/Project/GetSummary/",
    },
    kpisResults: {
      getYearsAndMonths: "/Innovation/api/KPI/Result/Index",
      list: "/Innovation/api/KPI/Result/List",
      submit: "/Innovation/api/KPI/Result/Submit",
      KpiInnovation: "/Innovation/api/KPI/Dashboard/Innovation",
      KpiInnovationReadiness: "/Innovation/api/KPI/Dashboard/Readiness",
    },
  };

  public static transition = {
    add: "/WorkflowEngine/api/Transition/Add",
    update: "/WorkflowEngine/api/Transition/Update",
    delete: "/WorkflowEngine/api/Transition/Delete",
  };

  public static BAU = {
    MainTasks: {
      getDetails: "/BAU/api/MainTask/GetDetails",
    },
    Tasks: {
      getTasks: "/BAU/api/MainTask/GetTasks",
      getDetails: "/BAU/api/SubTask/Get",
      getFiles: "/BAU/api/SubTask/GetFiles",
      getHistory: "/BAU/api/SubTask/GetHistory",
      updateProgress: "/BAU/api/SubTask/UpdateProgress",
      addComment: "/BAU/api/SubTask/Comments/Add",
      updateStatus: "/BAU/api/SubTask/UpdateStatus",
      verifyTask: "/BAU/api/SubTask/Verify",
    },
    Roles: {
      getRoles: "/BAU/api/BusinessRole/Search",
      create: "/BAU/api/BusinessRole/Create",
      update: "/BAU/api/BusinessRole/Update",
      delete: "/BAU/api/BusinessRole/Delete",
      DownloadTemplate: "/BAU/api/BusinessRole/DownloadTemplate",
      importTemplate: "/BAU/api/BusinessRole/Import",
    },
    Dashboard: {
      getMainTasks: "/BAU/api/Dashboard/TotalMainTasks",
      getTotalSubTasks: "/BAU/api/Dashboard/TotalSubTasks",
      getOverAllProgress: "/BAU/api/Dashboard/OverallProgress",
      getSectorPerformance: "/BAU/api/Dashboard/SectorsPerformance",
      getBestContributers: "/BAU/api/Dashboard/BestContributors",
      getTasksPerMontth: "/BAU/api/Dashboard/TasksStatusPerMonth",
      getActualVSPlannedProgress: "/BAU/api/Dashboard/ActualVsPlannedProgress",
      getBudgetStatistics: "/BAU/api/Dashboard/BudgetStatistics",
      getTasksStatusPerQuarter: "/BAU/api/Dashboard/TasksStatusPerQuarter",
      getRolesCoverage: "/BAU/api/Dashboard/RolesCoverage",
      getTasksDetails: "/BAU/api/Dashboard/TasksDetails",
      getMainTasksByYear: "/BAU/api/MainTask/Get",
    },
    TasksManagement: {
      checkBoard: "/BAU/api/TaskBoard/Check",
      createBoard: "/BAU/api/TaskBoard/Create",
      statistics: "/BAU/api/TaskBoard/Summary/",
      getBoard: "/BAU/api/TaskBoard/Get",
      export: "/BAU/api/TaskBoard/Export",
      getIsights: "/BAU/api/TaskBoard/GetInsights",
      getAllBoards: "/BAU/api/TaskBoard/GetAllTaskBoards",
      getGroupRoles: "/BAU/api/BusinessRole/GetGroupRoles",
      getAvailableBudgetMainTask: "/BAU/api/TaskBoard/AvailableBudget/",
      getAvailableBudgetTask: "/BAU/api/MainTask/AvailableBudget/",
      createMainTask: "/BAU/api/MainTask/Create",
      editMainTask: "/BAU/api/MainTask/Update",
      createSubTask: "/BAU/api/SubTask/Create",
      editSubTask: "/BAU/api/SubTask/Update",
      getMainTasks: "/BAU/api/MainTask/get/",
      getSubTaskDetails: "/BAU/api/SubTask/Get",
      searchFollowUp: "/BAU/api/SubTask/FollowUp/GetToImport",
      changeBudget: "/BAU/api/TaskBoard/UpdateBudget",
      deleteMainTask: "/BAU/api/MainTask/Delete/",
      deleteSubTask: "/BAU/api/SubTask/Delete/",
      getCount: "/BAU/api/SubTask/GetCount",
      getProgress: "/BAU/api/TaskBoard/Progress",
      getInsightsTasks: "/BAU/api/TaskBoard/Insights/Tasks",
      getInsightsBudget: "/BAU/api/TaskBoard/Insights/Budget",
      getInsightsRoleCoverage: "/BAU/api/TaskBoard/Insights/RoleCoverage",
      getInsightsEmployeeWorkload:
        "/BAU/api/TaskBoard/Insights/EmployeeWorkload",
      getInsightsSectionWorkload: "/BAU/api/TaskBoard/Insights/SectionWorkload",
    },
  };
  public static EA = {
    getCount: "/Appraisal/api/EmployeeScore/GetCount",
    Dashboard: {
      employeeLevel: "/Appraisal/api/Dashboard/EmployeesLevels",
      performanceArea: "/Appraisal/api/Dashboard/PerformancePerArea",
      ScoresPerGroup: "/Appraisal/api/Dashboard/ScoresPerGroup",
      TrainingPerformance: "/Appraisal/api/Dashboard/TrainingPerformance",
      BestPerformance: "/Appraisal/api/Dashboard/BestPerformance",
      LowPerformance: "/Appraisal/api/Dashboard/LowPerformance",
      TrainingCoursesPerGroup:
        "/Appraisal/api/Dashboard/TrainingCoursesPerGroup",
      getYearsPeriods: "/Appraisal/api/Dashboard/GetYearsPeriods",
    },
    Courses: {
      list: "/Appraisal/api/Course/GetCourses",
      listByEmployee: "/Appraisal/api/Course/GetCourses",
      create: "/Appraisal/api/Course/Create",
      update: "/Appraisal/api/Course/Update",
      delete: "/Appraisal/api/Course/Delete",
      cancel: "/Appraisal/api/Course/Cancel",
      close: "/Appraisal/api/Course/Close",
      getCourseDetails: "/Appraisal/api/Course/GetDetails",
      getTrainingClassifications:
        "/Appraisal/api/Course/GetTrainingClassifications",
      addInvitees: "/Appraisal/api/Course/AddInvitees",
      updateAttendanceStatus: "/Appraisal/api/Course/UpdateAttendanceStatus",
      DownloadTemplate: "/Appraisal/api/Course/Import/DownloadTemplate",
      uploadFile: "/Appraisal/api/Course/Import",
      export: "Appraisal/api/Course/Export",
      downloadInviteesTemplate:
        "/Appraisal/api/Course/ImportInvitees/DownloadTemplate",
      uploadInvitees: "/Appraisal/api/Course/ImportInvitees",
    },
    StaticKpis: {
      list: "/Appraisal/api/KPI/GetAll",
      getKpiDetails: "/Appraisal/api/KPI/GetDetails",
      create: "/Appraisal/api/KPI/Create",
      update: "/Appraisal/api/KPI/Update",
    },
    HappinessKpis: {
      list: "/Appraisal/api/HappinessKPIs/Results",
      importResults: "/Appraisal/api/HappinessKPIs/ImportResults",
      importTemplate: "/Appraisal/api/HappinessKPIs/ImportTemplate",
      updateResults: "/Appraisal/api/HappinessKPIs/UpdateResult",
    },
    Planning: {
      list: "/Appraisal/api/EmployeeScore/GetAll",
      employee: "/Appraisal/api/EmployeeScore/Get/",
      dynamicKpis: "/Appraisal/api/EmployeeScore/DynamicKPIs/",
      KpisSettings: "/Appraisal/api/Settings/DynamicKPIs/GetAll",
      staticKpis: "/Appraisal/api/KPI/GetActive",
      Competencies: "/Appraisal/api/EmployeeScore/DynamicKPIs/",
      updateDynamic: "/Appraisal/api/EmployeeScore/DynamicKPIs/Update",
      validateSystemModule: "/Appraisal/api/EmployeeScore/ValidateSystemModule",
      submit: "/Appraisal/api/EmployeeScore/Submit/",
      sendReminder: "/Appraisal/api/EmployeeScore/SendReminder",
      getEmployeeYears: "/Appraisal/api/EmployeeScore/GetEmployeeYears",
      UpdateResults: "/Appraisal/api/EmployeeScore/StaticKPIs/UpdateResults",
      UpdateKpisSettings: "/Appraisal/api/Settings/DynamicKPIs/Update",
      getCourses: "/Appraisal/api/EmployeeScore/Training",
      UpdateCompetenciesScore:
        "/Appraisal/api/EmployeeScore/Competencies/UpdateResults",
      getYearsPeriods: "/Appraisal/api/EmployeeScore/GetYearsPeriods",
      getYearlyReports: "/Appraisal/api/EmployeeScore/PerformancePerArea/",
      levelsStatistics: "/Appraisal/api/EmployeeScore/LevelsStatistics",
      submitResult: "/Appraisal/api/EmployeeScore/SubmitResults/",
      GetTotalResult: "/Appraisal/api/EmployeeScore/GetTotalResult",
      IsHappinessKPIsRequired:
        "/Appraisal/api/EmployeeScore/IsHappinessKPIsRequired",
      ModuleResultDetails:
        "/Appraisal/api/EmployeeScore/ModuleResult/GetDetails",
    },
    Competencies: {
      list: "/Appraisal/api/Competency/GetAll",
      listScoreSheet: "/Appraisal/api/EmployeeScore/Competencies/",
      getGrades: "/Appraisal/api/Competency/GetGrades",
      getCategories: "/Appraisal/api/Competency/GetCategories",
      getLevels: "/Appraisal/api/Competency/GetLevels",
      create: "/Appraisal/api/Competency/Create",
      update: "/Appraisal/api/Competency/Update",
      delete: "/Appraisal/api/Competency/Delete",
      toggleStatus: "/Appraisal/api/Competency/ToggleStatus",
    },
  };

  public static Partnership = {
    Lookup: {
      partnershipTypes: "/Partnership/api/Lookup/PartnershipTypes/GetAll",
      partnershipEntities: "/Partnership/api/Lookup/PartnershipTypes/GetAll",
      addedValues: "/Partnership/api/Lookup/AddedValues/GetAll",
      agreementDurations: "/Partnership/api/Lookup/AgreementDurations/GetAll",
      ContractDefaultText: "/Partnership/api/Lookup/Contracts/GetAll",
      PartnershipCommunicationTypes:
        "/Partnership/api/Lookup/PartnershipCommunicationTypes/GetAll",
      raesonList: "/Partnership/api/Lookup/Reasons/GetAll",
      updateRaesonList: "/Partnership/api/Lookup/Reasons/Update",
      renewRaesonList: "/Partnership/api/Lookup/Reasons/Renew",
      cancelRaesonList: "/Partnership/api/Lookup/Reasons/Cancel",
      terminateRaesonList: "/Partnership/api/Lookup/Reasons/Terminate",
    },
    updatePartnershipType:
      "/Partnership/api/Partnership/Update/PartnershipType",
    list: "/Partnership/api/Partnership/Get",
    getList: "/Partnership/api/Partnership/GetList",
    get: "/Partnership/api/Partnership/Get",
    Statistics: "/Partnership/api/Partnership/Get/Statistics",
    Details: "/Partnership/api/Partnership/Details",
    RequestDetails: "/Partnership/api/Partnership/Request/Details",
    SavePartnership: "/Partnership/api/Partnership/Save",
    ActionButtons: "/Partnership/api/Partnership/ActiveActionButtons/",
    Partners: {
      list: "/Partnership/api/Partners/Get",
      verified: "/Partnership/api/Partners/GetVerified",
      dropList: "/Partnership/api/Partners/Get/DropList",
      Details: "/Partnership/api/Partners/FullProfile",
      info: "/Partnership/api/Partners/Info",
      Statistics: "/Partnership/api/Partners/Get/Statistics",
      invitedStatistics: "/Partnership/api/Partners/GetInvited/Statistics",
      invitePartner: "/Partnership/api/Partners/Invite",
      getById: "/Partnership/api/Partners/Get",
      coPartnersRequest: "/Partnership/api/Partners/CoPartner/Get",
      coPartnersPartnership:
        "/Partnership/api/Partners/CoPartner/Get/Partnerships",
      isUserLegal: "/Partnership/api/Partners/Users/IsLegal",
      export: "/Partnership/api/Partners/Export",
    },
    Contacts: {
      list: "/Partnership/api/Partnership/Contact/Get",
      create: "/Partnership/api/Partnership/Contact/Create",
      delete: "/Partnership/api/Partnership/Contact/Delete",
      requestList: "/Partnership/api/Partnership/Contact/Request/Get",
      requestCreate: "/Partnership/api/Partnership/Contact/Request/Create",
      requestDelete: "/Partnership/api/Partnership/Contact/Request/Delete",
    },
    AuthorizationSignature: {
      list: "/Partnership/api/Partnership/AuthorizationSignature/Get",
      create: "/Partnership/api/Partnership/AuthorizationSignature/Create",
      update: "/Partnership/api/Partnership/AuthorizationSignature/Update",
      delete: "/Partnership/api/Partnership/AuthorizationSignature/Delete",
      requestList:
        "/Partnership/api/Partnership/AuthorizationSignature/Request/Get",
      requestCreate:
        "/Partnership/api/Partnership/AuthorizationSignature/Request/Create",
      requestUpdate:
        "/Partnership/api/Partnership/AuthorizationSignature/Request/Update",
      requestDelete:
        "/Partnership/api/Partnership/AuthorizationSignature/Request/Delete",
    },
    Contract: {
      get: "/Partnership/api/Partnership/Contract/Get",
      create: "/Partnership/api/Partnership/Contract/Create",
      update: "/Partnership/api/Partnership/Contract/Update",
      requestGet: "/Partnership/api/Partnership/Contract/Request/Get",
      geyByRequestType: "/Partnership/api/Contracts/GetByPartnershipTypeId",
      getContractByRequestId: "/Partnership/api/Partnership/Contract/Request",
      requestCreate: "/Partnership/api/Partnership/Contract/Request/Create",
      requestUpdate: "/Partnership/api/Partnership/Contract/Request/Update",
      uploadContract: "/Partnership/api/Partnership/Contract/Request/Upload",
    },
    Comments: {
      list: "/Partnership/api/Partnership/{id}/Comment/GetAll",
      add: "/Partnership/api/Partnership/{id}/Comment/Add",
      get: "/Partnership/api/Partnership/Contract/Get",
      create: "/Partnership/api/Partnership/Contract/Create",
      update: "/Partnership/api/Partnership/Contract/Update",
      requestList: "/Partnership/api/Partnership/Request/{id}/Comment/GetAll",
      requestAdd: "/Partnership/api/Partnership/Request/{id}/Comment/Add",
    },
    Workflow: {
      perform: "/Partnership/api/Workflow/Perform",
    },
    Risks: {
      getAll: "/Partnership/api/Partnership/Risk/GetAll",
      create: "/Partnership/api/Partnership/Risk/Create",
      update: "/Partnership/api/Partnership/Risk/Update",
      delete: "/Partnership/api/Partnership/Risk/Delete",
      export: "/Partnership/api/Partnership/Risk/ExportExcel/",
    },
    Communications: {
      getAll: "/Partnership/api/Partnership/Communication/GetAll",
      getById: "/Partnership/api/Partnership/Communication/Get",
      create: "/Partnership/api/Partnership/Communication/Create",
      update: "/Partnership/api/Partnership/Communication/Update",
      delete: "/Partnership/api/Partnership/Communication/Delete",
    },
    Tasks: {
      getAll: "/Partnership/api/Partnership/Task/Get",
      getById: "/Partnership/api/Partnership/Task/Get/Id",
      create: "/Partnership/api/Partnership/Task/Create",
      update: "/Partnership/api/Partnership/Task/Update",
      delete: "/Partnership/api/Partnership/Task/Delete",
      changeStatus: "/Partnership/api/Partnership/Task/ChangeStatus",
      updateProgress: "//Partnership/api/Partnership/Task/UpdateProgress",
      exportExcel: "/Partnership/api/Partnership/Task/ExportExcel",
      getHistory: "/Partnership/api/Partnership/Task/GetHistory",
      getFiles: "/Partnership/api/Partnership/Task/GetFiles",
      Comments: {
        create: "/Partnership/api/Partnership/TaskComment/Create",
      },
    },
    Beneficiary: {
      create: "/Partnership/api/Partnership/Beneficiary/Create",
      update: "/Partnership/api/Partnership/Beneficiary/Update",
      getAll: "/Partnership/api/Partnership/Beneficiary/GetAll",
      delete: "/Partnership/api/Partnership/Beneficiary/Delete",
      exportExcel: "/Partnership/api/Partnership/Beneficiary/Export",
    },
    partnershipChanges: {
      update: "/Partnership/api/Partnership/ChangeRequest/Update",
      renew: "/Partnership/api/Partnership/ChangeRequest/Renew",
      cancel: "/Partnership/api/Partnership/ChangeRequest/Cancel",
      terminate: "/Partnership/api/Partnership/ChangeRequest/Terminate",
    },
    requests: {
      getById: "/Partnership/api/Partnership/history/Get",
      exportExcel: "/Partnership/api/Partners/Export",
    },
    KPIs: {
      getAll: "/Partnership/api/Partnership/Kpi/Get",
      create: "/Partnership/api/Partnership/Kpi/Create",
      update: "/Partnership/api/Partnership/Kpi/Update",
      updateProgress: "/Partnership/api/Partnership/Kpi/UpdateProgress",
      export: "/Partnership/api/Partnership/Kpi/Export/",
      getById: "/Partnership/api/Partnership/Kpi/GetById",
      getStatistics: "/Partnership/api/Partnership/Kpi/Get/Statistics",
    },
    evaluation: {
      get: "/Partnership/api/partnership/Evaluation/Get",
    },
    Topics: {
      getAll: "/Partnership/api/Topics/Get",
      getById: "/Partnership/api/Topics/Get",
      getLatest: "/Partnership/api/Topics/GetLatest",
      create: "/Partnership/api/Topics/Create",
      update: "/Partnership/api/Topics/Update",
      delete: "/Partnership/api/Topics/Delete",
      details: "/Partnership/api/Topics/Details",
      addComment: "/Partnership/api/Topics/{topicId}/Comment/Add",
      getAllComments: "/Partnership/api/Topics/{topicId}/Comment/GetAll",
    },
    evaluations: {
      getAll: "/Partnership/api/EvaluationCriteria/GetAll",
      getById: "/Partnership/api/EvaluationCriteria/Get/",
      create: "/Partnership/api/EvaluationCriteria/Create",
      update: "/Partnership/api/EvaluationCriteria/Update",
      delete: "/Partnership/api/EvaluationCriteria/Delete/",
      canSubmit:
        "/Partnership/api/partnership/Evaluation/CanSubmit/Evaluation/",
      getRatingDetails:
        "/Partnership/api/partnership/Evaluation/GetRatingDetails/",
    },
    contracts: {
      getAll: "/Partnership/api/Contracts/GetAll",
      create: "/Partnership/api/Contracts/Create",
      update: "/Partnership/api/Contracts/Update",
      delete: "/Partnership/api/Contracts/Delete/",
      getById: "/Partnership/api/Contracts/GetById/",
      getVariables: "/Partnership/api/Contracts/GetVariables",
    },
    rate: {
      submit: "/Partnership/api/partnership/Evaluation/SubmitEvaluation",
      update: "/Partnership/api/partnership/Evaluation/UpdateRating",
    },
    dashboard: {
      Statistics: "/Partnership/api/Dashboard/Statistics/Partnership",
      PartnershipTypes: "/Partnership/api/Dashboard/PartnershipTypes",
      PartnerStat: "/Partnership/api/Dashboard/Statistics/Partner",
      PartnerGovernmentTypes:
        "/Partnership/api/Dashboard/PartnerGovernmentTypes",
      PartnerRatings: "/Partnership/api/Dashboard/PartnerRatings",
      EnterpriseIndicators: "/Partnership/api/Dashboard/EnterpriseIndicators",
    },
  };

  public static AdminSettings = {
    listSettings: "/Utilities/api/admin/setting/list",
    updateSetting: "/Utilities/api/admin/setting/update",
  };

  public static Survey = {
    CsatTargets: {
      GetAnnualConfiguration: '/Utilities/api/admin/csat-targets',
      Save: '/Utilities/api/admin/csat-targets/save',
    },
    SatisfactionConfig: {
      Base: '/Utilities/api/public/satisfaction-configurations',
    },
  };

  public static EntityDashboard = {
    Lookups:              '/Utilities/api/entity/dashboard/lookups',
    RatingLookups:        '/Utilities/api/entity/dashboard/rating-lookups',
    Summary:              '/Utilities/api/entity/dashboard/summary',
    SatisfactionOverTime: '/Utilities/api/entity/dashboard/satisfaction-over-time',
    ServiceSatisfaction:  '/Utilities/api/entity/dashboard/service-satisfaction',
    ChartGender:          '/Utilities/api/entity/dashboard/charts/gender',
    ChartAge:             '/Utilities/api/entity/dashboard/charts/age',
    ChartNationality:     '/Utilities/api/entity/dashboard/charts/nationality',
    ChartUserType:        '/Utilities/api/entity/dashboard/charts/user-type',
    Feedback:             '/Utilities/api/entity/dashboard/feedback',
    SummaryDrilldown:     '/Utilities/api/entity/dashboard/summary-drilldown',
    Respondent:           '/Utilities/api/entity/dashboard/respondents',
  };

  public static DetailedReport = {
    Lookups:          '/Utilities/api/detailed/report/lookups',
    Summary:          '/Utilities/api/detailed/report/summary',
    FeedbackDist:     '/Utilities/api/detailed/report/feedback-distribution',
    Feedback:         '/Utilities/api/detailed/report/feedback',
    SummaryDrilldown: '/Utilities/api/detailed/report/summary-drilldown',
    Respondent:       '/Utilities/api/detailed/report/respondents',
  };

  public static ActivitySharingDashboard = {
    Summary:            '/Utilities/api/activity-sharing/dashboard/summary',
    AuthDistribution:   '/Utilities/api/activity-sharing/dashboard/authentication-distribution',
    AuthByActivityType: '/Utilities/api/activity-sharing/dashboard/authentication-by-activity-type',
    TopSharedItems:     '/Utilities/api/activity-sharing/dashboard/top-shared-items',
    SharesByChannel:    '/Utilities/api/activity-sharing/dashboard/shares-by-channel',
    SharesByPlatform:   '/Utilities/api/activity-sharing/dashboard/shares-by-platform',
    LookupsSharesType:  '/Utilities/api/activity-sharing/dashboard/lookups-shares-type',
    Logs:               '/Utilities/api/activity-sharing/dashboard/logs',
  };

  public static ExecutiveSatisfactionDashboard = {
    Lookups:             '/Utilities/api/executive/dashboard/lookups',
    Overview:            '/Utilities/api/executive/dashboard/platform-overview',
    CategoryBreakdown:   '/Utilities/api/executive/dashboard/survey-category-breakdown',
    ChannelAverage:      '/Utilities/api/executive/dashboard/channel-average',
    EntityHeatmap:       '/Utilities/api/executive/dashboard/entity-satisfaction-heatmap',
    TopBottomServices:   '/Utilities/api/executive/dashboard/top-bottom-services',
    Trend:               '/Utilities/api/executive/dashboard/csat-monthly-trend',
    Gender:              '/Utilities/api/executive/dashboard/users-by-gender',
    Age:                 '/Utilities/api/executive/dashboard/users-by-age',
    Nationality:         '/Utilities/api/executive/dashboard/users-by-nationality',
    UserType:            '/Utilities/api/executive/dashboard/user-type',
    RecentComments:      '/Utilities/api/executive/dashboard/recent-comments',
    RespondentFeedback:  '/Utilities/api/executive/dashboard/respondent-feedback',
    KpisDrilldown:       '/Utilities/api/executive/dashboard/kpis-drilldown',
    EntitiesBelowTarget: '/Utilities/api/executive/dashboard/entities-below-target',
    EntityPerformance:   '/Utilities/api/executive/dashboard/entity-performance',
  };

  public static GlobalSatisfactionDashboard = {
    Overview:          '/Utilities/api/admin/global-satisfaction-dashboard/overview',
    CategoryBreakdown: '/Utilities/api/admin/global-satisfaction-dashboard/category-breakdown',
    ChannelAverages:   '/Utilities/api/admin/global-satisfaction-dashboard/channel-averages',
    EntityHeatmap:     '/Utilities/api/admin/global-satisfaction-dashboard/entity-heatmap',
    TopBottomServices: '/Utilities/api/admin/global-satisfaction-dashboard/top-bottom-services',
    Trend:             '/Utilities/api/admin/global-satisfaction-dashboard/trend',
    Gender:            '/Utilities/api/admin/global-satisfaction-dashboard/respondent-profile/gender',
    Age:               '/Utilities/api/admin/global-satisfaction-dashboard/respondent-profile/age',
    Nationality:       '/Utilities/api/admin/global-satisfaction-dashboard/respondent-profile/nationality',
    UserType:          '/Utilities/api/admin/global-satisfaction-dashboard/respondent-profile/user-type',
    Comments:          '/Utilities/api/admin/global-satisfaction-dashboard/comments',
    Shares:            '/Utilities/api/admin/global-satisfaction-dashboard/shares',
  };

  public static FundboxManagement = {
    list: "/Donation/api/admin/FundBox/list",
    details: "/Donation/api/admin/FundBox/details/",
    update: "/Donation/api/admin/FundBox/update",
    create: "/Donation/api/admin/FundBox/create",
    activate: "/Donation/api/admin/FundBox/activate",
    deactivate: "/Donation/api/admin/FundBox/deactivate",
    getOrganizationsLookups: "/Donation/api/my/organizations",
    getDonationList: "/Donation/api/admin/FundBox/donations",
    FundboxStatus: "/Donation/api/public/lookups/fundbox-status",
    getPaymentGatewayItems: "/Payment/api/my/accounts",
    getFundBoxes: "/Donation/api/my/fundboxs",
    getFundboxOrganizations:
      "/Donation/api/public/lookups/fundbox-organizations",
    FundBoxes: "/Donation/api/public/lookups/fundbox-types",
  };

  public static Donations = {
    // GiftCardCategries
    GiftCardCategriesList: "/Donation/api/admin/gift-card-category/list/search",
    GiftCardCategriesAllList: "/Donation/api/admin/gift-card-category/list",
    GiftCardCategriesDetails: "/Donation/api/admin/gift-card-category/details",
    GiftCardCategriesUpdate: "/Donation/api/admin/gift-card-category/update",
    GiftCardCategriesCreate: "/Donation/api/admin/gift-card-category/create",
    GiftCardCategriesActivate:
      "/Donation/api/admin/gift-card-category/activate",
    GiftCardCategriesOrganization: "/Donation/api/my/organizations",
    GiftCardCategriesDeactivate:
      "/Donation/api/admin/gift-card-category/deactivate",
    GiftCardCategriesStatus: "/Donation/api/public/lookups/category-status",
    // GiftCardTemplates
    GiftCardTemplatesList: "/Donation/api/admin/gift-card-template/list",
    GiftCardTemplatesDetails: "/Donation/api/admin/gift-card-template/details",
    GiftCardTemplatesUpdate: "/Donation/api/admin/gift-card-template/update",
    GiftCardTemplatesCreate: "/Donation/api/admin/gift-card-template/create",
    GiftCardTemplatesActivate:
      "/Donation/api/admin/gift-card-template/activate",
    GiftCardTemplatesDeactivate:
      "/Donation/api/admin/gift-card-template/deactivate",
    GiftCardTemplatesStatus: "/Donation/api/public/lookups/giftcard-status",
    GiftCardReportsList: "/Donation/api/admin/gift-card-donation/report",
    DeliveryMethodsLookup:
      "/Donation/api/public/lookups/gift-card-delivery-types",
    PaymentStatusesLookup: "/Donation/api/public/lookups/payment-status",
    GiftCardCategoriesLookup: "/Donation/api/my/giftcard-categories",
    GiftCardTemplatesLookup: "/Donation/api/my/giftcard-template",
    GetPaymentStatus: "/Donation/api/public/lookups/payment-status",
  };
  public static Loyalty = {
    getMemberShip: "/LpBackend/api/Membership/Active",
    getCenter: "/LpBackend/api/centers",
    getMemberShipNFC: "/LpBackend/api/MembershipNFC",
    MemberShipNFCStatus: "/LpBackend/api/MembershipNFC/status",

    getOrg: "/LpBackend/api/Organization",
    getActivityConfiguration: "/LpBackend/api/ActivityConfiguration",
    ActivityType: "/LpBackend/api/ActivityType",
    events: "/LpBackend/api/Event",
    CreateLoyaltyConfiguration: "/LpBackend/api/LoyaltyConfiguration",
    UpdateLoyaltyConfiguration: "/LpBackend/api/LoyaltyConfiguration",
    DeleteLoyaltyConfiguration: "/LpBackend/api/ActivityConfiguration/",

    getLoyaltyConfiguration: "/LpBackend/api/LoyaltyConfiguration",
    createActivityConfiguration: "/LpBackend/api/ActivityConfiguration",
    Gifts: "/LpBackend/api/Gifts",
    GiftTypes: "/LpBackend/api/GiftTypes",
    Orders: "/LpBackend/api/Order",
    DeleteOrderItem: "/LpBackend/api/Order/orderitem",
    updateOrderItemStatus: "/LpBackend/api/OrderItems/status",

    Attachments: "/Attachments",
    orgCenters: "/LpBackend/api/OrganizationCenters",
    tier: "/LpBackend/api/Tier",
    Attendance: {
      statistics: "/LpBackend/api/Attendance/statistics",
      list: "/LpBackend/api/Attendance",
      create: "/LpBackend/api/Attendance",
      export: "/LpBackend/api/Attendance/export-excel-report",

      points: "/LpBackend/api/Attendance/points-report",
      uploadFile: "/LpBackend/api/Attendance/import",
    },
    allOrders: "/LpBackend/api/Dashboard/all-orders",
    exportAllOrders: "/LpBackend/api/Dashboard/export-all-orders",

    orderStatistic: "/LpBackend/api/Dashboard/order-statistic",
    distributionByTier: "/LpBackend/api/Dashboard/distribution-by-tier",
    orderchart: "/LpBackend/api/Dashboard/order-point-by-year",
    AdminAdjustPoints: "/LpBackend/api/AdminAdjustPoints",
    UserActivityStatistics: "/LpBackend/api/UserActivity/statistics",
    membershipWithGracePeriod:
      "/LpBackend/api/platform/membership-with-grace-period",
  };

  // Content Management
  public static ContentManagement = {
    Entities: {
      GetAll: "/HHEO/api/Organization/GetList",
      GetById: "/HHEO/api/Organization/GetById",
      Create: "/HHEO/api/Organization/Create",
      Update: "/HHEO/api/Organization/Update",
      Delete: "/HHEO/api/Organization/Delete",
      Activate: "/HHEO/api/Organization/ActivateOrganization",
      Deactivate: "/HHEO/api/Organization/DectivateOrganization",
    },
    Services: {
      GetAll: "/HHEO/api/Service/Get",
      GetById: "/HHEO/api/Service/GetDetails",
      GetByOrganizationId: "/HHEO/api/Service/GetListByOrganizationId",
      GetLookups: "/HHEO/api/Service/{serviceType}/lookups",
      Create: "/HHEO/api/Service/Create",
      Update: "/HHEO/api/Service/Update",
      Delete: "/HHEO/api/Service/Delete",
      ActivateDeactivate: "/HHEO/api/Service/activate-deactivate",
    },
    Booking: {
      GetAll: "/HHEO/api/Booking/GetAll",
      GetById: "/HHEO/api/Booking/Get",
      Create: "/HHEO/api/Booking/Create",
      Update: "/HHEO/api/Booking/Update",
      Delete: "/HHEO/api/Booking/Delete",
    },
    Membership: {
      GetAll: "/HHEO/api/Membership/GetAll",
      GetById: "/HHEO/api/Membership/Get",
      Create: "/HHEO/api/Membership/Create",
      Update: "/HHEO/api/Membership/Update",
      Delete: "/HHEO/api/Membership/Delete",
    },
    Lookups: {
      GetContentTypes: "/HHEO/api/Lookups/ContentTypes",
      GetContentStatuses: "/HHEO/api/Lookups/ContentStatuses",
      GetCategories: "/HHEO/api/Lookups/Categories",
    },
  };

  // Dashboard Logging (Authentication & OTP Logs)
  public static DashboardLogging = {
    Statistics: "/Identity/api/DashboardLogging/Statistics",
    LoggingSignInLogs: "/Identity/api/DashboardLogging/LoggingSignInLoggs",
    OTPLogs: "/Identity/api/DashboardLogging/OTPLoggs",
    Lookups: "/Identity/api/DashboardLogging/lookups",
  };
}
